'use client';

import useSWR from "swr";
import { useSearchParams } from 'next/navigation';

const fetcher = async <T>(url: string): Promise<T> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 20000); // 10-second timeout

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${process.env.NEXT_PUBLIC_TOKEN}`,
      },
      signal: controller.signal, // Pass the AbortController signal
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data. Please try again later.");
  } finally {
    clearTimeout(timeoutId); // Clear the timeout
  }
};

interface Post {
  id: number;

  title_en: string;
  title_ar: string;
  title_fr: string;
  title_de: string;
  title_es: string;
  title_it: string;
  title_pt: string;
  title_nl: string;
  title_ru: string;
  title_sv: string;
  image: string;

  content_en: string;
  content_ar: string;
  content_fr: string;
  content_de: string;
  content_es: string;
  content_it: string;
  content_pt: string;
  content_nl: string;
  content_ru: string;
  content_sv: string;
  old_price:string;
  new_price:string;
  dropshippingID:string;
  instock:string;
}

const useFetchCategoryProductsSearch = () => {
    const searchParams = useSearchParams();
    const query = searchParams.get('q'); // Get the search query from the URL
  const { data, error, isLoading } = useSWR<Post[]>(
    `${process.env.NEXT_PUBLIC_URL}product/?category__in=${query}`,
    fetcher<Post[]>
  );

  return { Products: data || [], error, isLoading };
};

export default useFetchCategoryProductsSearch;